module.exports = __webpack_public_path__ + "b5359596ecc8c491138bdf6dd64d92b1.svg";